import { ReactNode, useCallback, useState } from 'react';
import { SidebarManagerContext } from '@/common/components/sidebar-manager/SidebarManagerContext.ts';
import { SidebarContext } from '@/common/components/sidebar/SidebarContext.ts';
import { useCloseOnNavigation } from '@/common/hooks/useCloseOnNavigation.ts';

export interface SidebarManagerProps {
  children?: ReactNode;
}

export const SidebarManager = ({ children }: SidebarManagerProps) => {
  const [currentSidebar, setCurrentSidebar] = useState<ReactNode>();
  const [isOpen, setIsOpen] = useState(false);
  const [sidebarId, setSidebarId] = useState(0);

  const showSidebar = (sidebar: ReactNode) => {
    setCurrentSidebar(sidebar);
    setSidebarId((id) => ++id);
    setIsOpen(true);
  };

  const closeSidebar = useCallback(() => setIsOpen(false), []);
  useCloseOnNavigation(closeSidebar);

  return (
    <SidebarManagerContext value={{ showSidebar }}>
      {children}
      <SidebarContext value={{ isOpen: isOpen, id: sidebarId, onClose: closeSidebar }}>
        {currentSidebar}
      </SidebarContext>
    </SidebarManagerContext>
  );
};
